var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 4C22.3478 4 19.8043 5.05357 17.9289 6.92893C16.0536 8.8043 15 11.3478 15 14C15 16.6522 16.0536 19.1957 17.9289 21.0711C19.8043 22.9464 22.3478 24 25 24C27.6522 24 30.1957 22.9464 32.0711 21.0711C33.9464 19.1957 35 16.6522 35 14C35 11.3478 33.9464 8.8043 32.0711 6.92893C30.1957 5.05357 27.6522 4 25 4ZM17.5 14C17.5 12.0109 18.2902 10.1032 19.6967 8.6967C21.1032 7.29018 23.0109 6.5 25 6.5C26.9891 6.5 28.8968 7.29018 30.3033 8.6967C31.7098 10.1032 32.5 12.0109 32.5 14C32.5 15.9891 31.7098 17.8968 30.3033 19.3033C28.8968 20.7098 26.9891 21.5 25 21.5C23.0109 21.5 21.1032 20.7098 19.6967 19.3033C18.2902 17.8968 17.5 15.9891 17.5 14ZM12.5225 26.5C11.8641 26.4974 11.2116 26.6247 10.6026 26.8748C9.99348 27.1249 9.43976 27.4927 8.97315 27.9572C8.50654 28.4217 8.13621 28.9738 7.88342 29.5818C7.63062 30.1897 7.50032 30.8416 7.5 31.5C7.5 35.7275 9.5825 38.915 12.8375 40.9925C16.0425 43.035 20.3625 44 25 44C29.6375 44 33.9575 43.035 37.1625 40.9925C40.4175 38.9175 42.5 35.725 42.5 31.5C42.5 30.1739 41.9732 28.9021 41.0355 27.9645C40.0979 27.0268 38.8261 26.5 37.5 26.5H12.5225ZM10 31.5C10 30.1175 11.12 29 12.5225 29H37.5C38.163 29 38.7989 29.2634 39.2678 29.7322C39.7366 30.2011 40 30.837 40 31.5C40 34.7725 38.445 37.21 35.8175 38.8825C33.1425 40.59 29.3375 41.5 25 41.5C20.6625 41.5 16.8575 40.59 14.1825 38.8825C11.5575 37.2075 10 34.775 10 31.5Z",
    fill: "#1731AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ab57146ab7fd67df212f9cdf61c01196.svg";
export { ForwardRef as ReactComponent };